import { combineReducers } from "redux";
import profileReducer from "./Profile/profileReducer";
import commonReducer from './common';
const rootReducer = combineReducers({
    profileReducer: profileReducer,
    commonReducer,
});

export default rootReducer;
